import CreateTrackManager from "@/services/createTrackManager";

export default {
  install(app) {
    const createTrackManager = new CreateTrackManager();
    app.config.globalProperties.$createTrackManager = createTrackManager;
    app.provide("createTrackManager", createTrackManager);
  },
};
